import { useContext, useEffect, useState } from "react";
import { UserContext, QCContext } from "../../context/UserContext";
import BoardView from "./BoardView";
import ScanView from "./ScanView";
import styles from './QcSort.module.css';
import { getConnectedStations } from "../../services/station";
import SubHeader from "../../components/SubHeader";
import StationSelection from "../../components/StationSelection";

function QcSort() {
  const {setAvailableLocations, workOrder, currentFactory} = useContext(UserContext);
  const [selectedPO, setSelectedPO] = useState(undefined);
  const [woPanelList, setWoPanelList] = useState({});
  const contextData = {
    selectedPO,
    setSelectedPO,
    woPanelList,
    setWoPanelList
  }

  useEffect(() => {
    loadData();
  }, [currentFactory.item_code])

  useEffect(() => {
    setWoPanelList({})
  }, [workOrder])

  async function loadData() {
    let connectedStations = await getConnectedStations({
      _factory_code: currentFactory.item_code,
      station: "qc"
    });

    setAvailableLocations(connectedStations.message.stations);
  }

  return (
    <QCContext.Provider value={contextData}>
      <SubHeader showWorkOrder={true} showSearch={true} showBackButton={false} subTitle={'QC Sorting'} right={<StationSelection />}></SubHeader>
      <div className="p-24">
        <ScanView></ScanView>
        {workOrder && workOrder.id != undefined && <BoardView></BoardView>}
        {(!workOrder || workOrder.id === undefined) && <div className={styles.errorWo}>Kindly search and select workorder to continue QC</div>}
      </div>
    </QCContext.Provider>
  );
}

export default QcSort;
